import { render, staticRenderFns } from "./Aquisicao.vue?vue&type=template&id=6b8089be&scoped=true&"
import script from "./Aquisicao.vue?vue&type=script&lang=js&"
export * from "./Aquisicao.vue?vue&type=script&lang=js&"
import style0 from "./Aquisicao.vue?vue&type=style&index=0&id=6b8089be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8089be",
  null
  
)

export default component.exports